import { z } from "zod"

export const ActionLinkSchema = z.object({
  id: z.string(),
  type: z.string(),
  expires_at: z.string(),
  executed_at: z.string().optional(),
  executed_by_id: z.string().optional(),
  properties: z.object({
    // AutomationHandoff
    title: z.string().optional(),
    prompt: z.string().optional(),
    // EmailDraft
    syncbox_draft_id: z.string().optional(),
    household_id: z.string().optional(),
    // ModifyRecord
    endpoint: z.string().optional(),
    http_method: z.string().optional(),
    params: z.record(z.any()).optional(),
    summary: z.string().optional(),
    count: z.number().optional(),
    details: z.array(z.string()).optional(),
    plan_count: z.number().optional(),
    description: z.string().optional(),
    max_sources: z.number().optional(),
    sources: z
      .array(z.object({ id: z.string(), name: z.string(), details: z.array(z.string()).optional() }))
      .optional(),
    actions: z
      .array(
        z.object({
          summary: z.string().optional(),
          details: z.array(z.string()).optional(),
          resource: z.string().optional(),
          action: z.string().optional(),
          count: z.number().optional(),
        })
      )
      .optional(),
    invalidate_queries: z.array(z.array(z.string())).optional(),
  }),
  deliverable_status: z
    .enum(["pending", "extracting", "rendering", "ready", "failed", "normalizing", "building", "draft"])
    .optional(),
})

export type ActionLink = z.infer<typeof ActionLinkSchema>
